import _ from "lodash";
import { FormattedMessage } from "react-intl";
import { toast } from "react-toastify";
import React from "react/lib/React"; /** Do not remove this import, it's used by the toast library. */
import simpleFetch from "../../../../utils/simpleFetch";
import { GET_RETROACTIVE_CREDITS, GET_RETROACTIVE_LIMIT_DATE } from "../../../utils/data/models";

export const getRetroactiveLimitDate = (clientId, callback) => {
    try {
        let result = undefined;
        simpleFetch("get", GET_RETROACTIVE_LIMIT_DATE.path.replace("{}", clientId), "").then(
            (response) => {
                result = _.isEmpty(response) ? null : response;
                callback(result);
            }          
        ).catch(() => {
            toast(<FormattedMessage id="validation.customMessages.serverErrors.retroactiveFetchError" />, {
                type: toast.TYPE.ERROR,
                autoClose: false,
            });
        });
    }
    catch (error) {
        toast(<FormattedMessage id="validation.customMessages.serverErrors.retroactiveFetchError" />, {
            type: toast.TYPE.ERROR,
            autoClose: false,
        });
    }
};

export const getRetroactiveCredits = (clientId, callback) => {

    if (!clientId) {
        throw new Error("The route does not have a client id parameter.");
    }

    try {
        const endpoint = GET_RETROACTIVE_CREDITS.path.replace("{}", clientId);
        simpleFetch("GET", endpoint, {}).then(
            (response) => {
                const result = _.isEmpty(response) ? {} : response;
                callback(result);
            }
        );
    }
    catch (e) {
        /** If a promise error for unauthorized is thrown (403) by simpleFetch we toast error. If not, we throw the error. */
        if (e.status === 403) {
            toast(<FormattedMessage id="error.403.title" />, {
                type: toast.TYPE.ERROR,
                autoClose: false,
            });
        }
        else {
            toast(<FormattedMessage id="error.unknown" />, {
                type: toast.TYPE.ERROR,
                autoClose: false,
            });
        }
        throw e;
    }
};

export const getRetroactiveBeginningDate = (dateString) => {
    // Split the input date string to get year, month, and day
    const [year, month, day] = dateString.split('-').map(Number);

    // Create a new Date object with the input values
    let date = new Date(year, month - 1, day); // month is 0-based in JavaScript

    // Format the new date back to yyyy-mm-dd
    let newYear = date.getFullYear();
    let newMonth = (date.getMonth() + 1).toString().padStart(2, '0'); // getMonth() returns 0-11
    let newDay = date.getDate().toString().padStart(2, '0');

    return `${newYear}-${newMonth}-${newDay}`;
};


// WEBPACK FOOTER //
// ./src/components/common/RetroactiveData/RetroactiveLimitHelper.js